// components
import { CasCRUDTable } from 'src/compass/shared/components';
import CommissionForm from './_internal/CommissionForm';

type Props = {
  readOnly?: boolean;
};

export default function CommissionsTab({ readOnly = false }: Props) {
  return (
    <CasCRUDTable
      entityTitle="Property"
      entity="CommissionProperty"
      columns={[
        {
          field: 'property',
          sortable: false,
        },
        {
          field: 'value',
          sortable: false,
        },
      ]}
      showPagination={false}
      showAddButton={false}
      showEditSingletonButton={!readOnly}
      includeExport={false}
      editForm={CommissionForm}
      canDelete={false}
    />
  );
}
